/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import IllustratedMessage from "@react/react-spectrum/IllustratedMessage";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import Button from "@react/react-spectrum/Button";
import InaccessibleDownloadFile from "dc-icons/frictionless/S_IlluEmptyLockedPDF_128.svg";
import ZipIcon from "dc-icons/organizer/emptystateillustrations/S_IlluDownloadZipFile_128.svg";

import NoPreviewCss from "./NoPreview.css";
import withMediaQuery from "dc-preview-utils/src/components/withMediaQuery";

const NoPreviewComponent = props => {
  const {
    errorMessageId,
    shouldShowDownloadMessage,
    shouldShowDownloadButton,
    fileExtension,
    clickHandler,
    mqState,
    shouldUseMobileModernViewer
  } = props;

  let NoPreviewFileIcon = InaccessibleDownloadFile;
  let noPreviewHeading = errorMessageId;
  let noPreviewDescription = "nopreview.downloadMessage";
  if (fileExtension === "zip") {
    noPreviewHeading = "nopreview.error.zipFile";
    noPreviewDescription = "nopreview.downloadMessageZipFile";
    NoPreviewFileIcon = ZipIcon;
  }

  const illustrationClass =
    mqState === "MOBILE"
      ? NoPreviewCss.illustrationMobile
      : mqState === "TABLET"
      ? NoPreviewCss.illustrationTablet
      : NoPreviewCss.illustrationDesktop;
  const wrapperClass = shouldUseMobileModernViewer
    ? NoPreviewCss.NoPreviewWrapperMobile
    : NoPreviewCss.NoPreviewWrapper;
  return (
    <div className={wrapperClass}>
      <IllustratedMessage
        className={illustrationClass}
        heading={<FormattedMessage id={noPreviewHeading} />}
        description={shouldShowDownloadMessage ? <FormattedMessage id={noPreviewDescription} /> : null}
        illustration={<NoPreviewFileIcon />}
      />
      {shouldShowDownloadButton ? (
        <FormattedMessage id="common.downloadFile">
          {txt => <Button className={NoPreviewCss.DownloadButton} label={txt} variant="cta" onClick={clickHandler} />}
        </FormattedMessage>
      ) : null}
    </div>
  );
};

export const NoPreview = withMediaQuery(NoPreviewComponent);
